import {CommonScenario} from './CommonScenario';
import {HemisphereLight} from '../HemisphereLight';
import {ColorInterpolation} from '../../../classes/ColorInterpolation';

declare const THREE: any;

export class Winter extends CommonScenario {

  protected createHemisphereLight(): HemisphereLight {
    return new HemisphereLight(
      new ColorInterpolation(
        new THREE.Color(0xffffff),
        new THREE.Color(.6, .6, .6)
      ),
      new ColorInterpolation(
        new THREE.Color(0xa9a9aa),
        new THREE.Color(.1, .1, .1)
      ),
      1
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/env/scenarios/Winter.ts